<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Selezione Multipla
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickIndietro" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>

    <v-card-text>
      <v-container>
        <v-row align="center" justify="center">
          <v-col class="my-0 py-0" cols="3">
            <!-- Text field del codice articolo -->
            <v-text-field
              label="Cod. Articolo"
              v-model="cod_articolo_search"
              v-on:keydown.enter.prevent="searchArticolo"
            >
              <template v-slot:prepend>
                <v-btn @click="searchArticolo" small>
                  <v-icon color="primary"> mdi-magnify </v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
          <v-col class="my-0 py-0" cols="3">
            <!-- Autocomplete della famiglia -->
            <v-autocomplete
              :items="items_famiglia"
              item-text="des"
              item-value="id_tabella"
              label="Famiglia"
              v-model="famiglia_search"
            >
              <template v-slot:append>
                <v-btn
                  @click="famiglia_search = null"
                  icon
                  small
                  v-if="famiglia_search != null"
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col class="my-0 py-0" cols="3">
            <!-- Autocomplete del tipo -->
            <v-autocomplete
              :items="items_tipo"
              item-text="des"
              item-value="id_tabella"
              label="Tipo"
              v-model="tipo_search"
            >
              <template v-slot:append>
                <v-btn
                  @click="tipo_search = null"
                  icon
                  small
                  v-if="tipo_search != null"
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col class="my-0 py-0" cols="3">
            <!-- Autocomplete della fornitura -->
            <v-autocomplete
              :items="items_fornitura"
              item-text="des"
              item-value="id_tabella"
              label="Fornitura"
              v-model="fornitura_search"
            >
              <template v-slot:append>
                <v-btn
                  @click="fornitura_search = null"
                  icon
                  small
                  v-if="fornitura_search != null"
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="my-0 py-0" cols="12">
            <!-- Tabella degli articoli selezionabili -->
            <v-data-table
              class="elevation-1"
              :headers="headers_articoli"
              :height="'30vh'"
              :items="items_articoli"
            >
              <template v-slot:top>
                <v-toolbar color="indigo" dense>
                  <v-toolbar-title class="white--text">
                    Articoli Selezionabili
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="selezionaTutti"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon
                          :color="
                            booleano_massivo == true ? 'primary' : 'error'
                          "
                        >
                          {{
                            booleano_massivo == true
                              ? "mdi-checkbox-multiple-marked"
                              : "mdi-close-box-multiple"
                          }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{
                        booleano_massivo == true ? "Selezione" : "Deselezione"
                      }}
                      Multipla
                    </span>
                  </v-tooltip>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <template v-slot:[`item.selezione`]="{ item }">
                <v-simple-checkbox
                  color="primary"
                  v-model="item.selezionato"
                ></v-simple-checkbox>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-if="items_articoli.length > 0">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <!-- Spazio delle tab dei moduli -->
            <v-tabs v-model="tab" align-with-title>
              <v-tabs-slider color="transparent"></v-tabs-slider>
              <v-tab
                active-class="indigo white--text"
                class="py-0 my-0"
                v-for="item in tabs_moduli"
                :key="item"
              >
                {{ item }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <!-- Ciclo Produzione -->
              <v-tab-item>
                <v-card>
                  <v-card-text class="px-0 py-0">
                    <ArticoloCicloFasiNew
                      :data="articolo_sel"
                      :id_articoli_sel="
                        items_articoli.filter((e) => e.selezionato === true)
                      "
                      :is_selezione_multipla="true"
                      :toolbar_save_btn="true"
                    />
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <!-- Distinta Base -->
              <v-tab-item>
                <v-card>
                  <v-card-text class="px-0 py-0">
                    <ModificaMultiplaDistintaBase
                      :items_ids="items_ids"
                    />
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Overlay di caricamento -->
    <v-overlay :value="caricamento_dati">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>
<script>
import ArticoloCicloFasiNew from "@/views/PRODUCTION/Articolo/CicoloFasi/ArticoloCicloFasiNew.vue";
import ModificaMultiplaDistintaBase from "@/components/PRODUCTION/SelezioneMultipla/ModificaMultiplaDistintaBase.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Articolo {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "barca", default_val: null },
      { nome: "calzata", default_val: 0 },
      { nome: "completata", default_val: 0 },
      { nome: "coperta", default_val: 0 },
      { nome: "data_consegna", default_val: "" },
      { nome: "date_mod", default_val: "" },
      { nome: "cod_articolo_child", default_val: "" },
      { nome: "des_articolo_child", default_val: "" },
      { nome: "des_commessa", default_val: "" },
      { nome: "guscio", default_val: 0 },
      { nome: "id_articolo_avo", default_val: null },
      { nome: "id_articolo_child", default_val: null },
      { nome: "id_responsabile", default_val: null },
      { nome: "id_checklist", default_val: null },
      { nome: "id_commessa", default_val: null },
      { nome: "id_commessa_dettaglio", default_val: null },
      { nome: "id_commessa_avo", default_val: null },
      { nome: "id_commessa_riepilogo", default_val: null },
      { nome: "magazzino", default_val: 0 },
      { nome: "matricola", default_val: "" },
      { nome: "ore", dafault_val: null },
      { nome: "rif_prem", default_val: 0 },
      { nome: "vassoio", dafault_val: 0 },
    ];

    return campi;
  }
}

export default {
  name: "SelezioneMultipla",
  components: {
    ArticoloCicloFasiNew,
    ModificaMultiplaDistintaBase,
    SnackbarQV,
  },
  props: {
    rotta_back: { type: String, default: "/home/production" },
  },
  data() {
    return {
      // Variabili d'appoggio
      articolo_sel: new Articolo(),
      booleano_massivo: true,
      cod_articolo_search: "",
      famiglia_search: null,
      fornitura_search: null,
      tab: 0,
      tipo_search: null,

      // Modal
      caricamento_dati: false,

      // Array
      headers_articoli: [
        { text: "Selezione", value: "selezione", sortable: false },
        { text: "Cod. Articolo", value: "cod_articolo", sortable: false },
        { text: "Des. Articolo", value: "des_articolo", sortable: false },
        { text: "Famiglia", value: "id_famiglia", sortable: false },
        { text: "Tipo", value: "id_tipo", sortable: false },
        { text: "Fornitura", value: "id_tipo_fornitura", sortable: false },
      ],
      items_articoli: [],
      items_famiglia: new Array(),
      items_fornitura: new Array(),
      items_tipo: new Array(),
      tabs_moduli: ["Ciclo Produzione", "Distinta Base"],
    };
  },
  computed: {
    items_ids() {
      const res = new Array();
      this.items_articoli
        .filter((a) => a.selezionato === true)
        .forEach((a) => {
          res.push(a.id_articolo);
        });

      return res;
    },
  },
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    clickIndietro() {
      this.$router.push(this.rotta_back);
    },
    getTabelle() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "'Famiglia','TIPOARTICOLO','FORNITURA_STANDARD'",
          filter: "validita = 1",
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        // Gestisco l'array PORTO che mi arriva dal BE
        this.items_famiglia = res.data.Famiglia ? res.data.Famiglia : [];
        this.items_fornitura = res.data.FORNITURA_STANDARD
          ? res.data.FORNITURA_STANDARD
          : [];
        this.items_tipo = res.data.TIPOARTICOLO ? res.data.TIPOARTICOLO : [];
      });
    },
    searchArticolo() {
      // Controllo che ci sia un codice
      if (this.cod_articolo_search == null || this.cod_articolo_search === "") {
        this.cod_articolo_search = "*";
      }

      const search_Articolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.user_token,
          cod_articolo: this.cod_articolo_search,
          id_famiglia: this.famiglia_search == null ? "" : this.famiglia_search,
          id_tipo: this.tipo_search == null ? "" : this.tipo_search,
          id_tipo_fornitura:
            this.fornitura_search == null ? "" : this.fornitura_search,
        },
      };

      // Attivo l'overlay di caricamento.
      this.caricamento_dati = true;

      // Eseguo la chiamata al BE
      this.$store
        .dispatch("api", search_Articolo)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            // Inserisco il campo di selezione negli oggetti restituiti dal BE.
            res.data.lista.forEach((elem) => {
              elem.selezionato = false;
            });

            this.items_articoli = res.data.lista;

            // Se la risposta è un array vuoto stampo anche una snackbar di avviso.
            if (res.data.length === 0) {
              this.$refs.SnackbarQV.print(
                "orange",
                "Non sono stati trovati articoli per questi criteri di ricerca."
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );

          this.caricamento_dati = false;
        });
    },
    selezionaTutti() {
      this.items_articoli.forEach((a) => {
        a.selezionato = this.booleano_massivo;
      });

      this.booleano_massivo = !this.booleano_massivo;
    },
  },
  created() {},
  mounted() {
    this.getTabelle();
  },
};
</script>
<style scoped>
</style>